import styled from 'styled-components';
import { Scrollbar } from '@ann/web-components';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 0 16px 0;
  flex-shrink: 0;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: background 0.15s ease;
  color: ${({ theme }) => theme.colors.neutralBlack ?? '#111827'};

  &:hover {
    background: ${({ theme }) => theme.colors.clearGray ?? '#F3F4F6'};
  }

  &:active {
    background: ${({ theme }) => theme.colors.neutral ?? '#E5E7EB'};
  }
`;

export const Title = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SearchWrapper = styled.div`
  flex-shrink: 0;
  padding-bottom: 12px;
`;

export const ListWrapper = styled(Scrollbar).attrs({
  size: 'small',
  display: 'flex',
  padding: '0',
})`
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-height: 0;
`;

export const GroupSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
`;

export const GroupLabel = styled.div`
  padding: 8px 8px 4px 8px;
`;

export const ConversationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 6px 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.12s ease;
  background: ${({ $isActive, theme }) =>
    $isActive ? (theme.colors.primaryLight ?? '#EFF4FF') : 'transparent'};

  &:hover {
    background: ${({ $isActive, theme }) =>
      $isActive
        ? (theme.colors.primaryLight ?? '#EFF4FF')
        : (theme.colors.clearGray ?? '#F9FAFB')};

    .chat-item-actions {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary ?? '#2173FF'};
    outline-offset: 1px;
  }
`;

export const ConversationTitleWrap = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ItemActions = styled.div`
  flex-shrink: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s ease;
`;

export const EditableTitleInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.neutralBlack ?? '#111827'};
  padding: 0;

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral ?? '#9CA3AF'};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
`;
